import { FileDownIcon } from "lucide-react"

import type { ButtonProps } from "@/components/ui/button"
import { Button } from "@/components/ui/button"
type ExportButtonProps = ButtonProps & {}
export const ExportButton = ({ ...props }: ExportButtonProps) => {
  return (
    <Button variant="outline" {...props}>
      <FileDownIcon size={16} className="mr-2" />
      Exportar CSV
    </Button>
  )
}
